/**
 * THE ONE CLIENT-SIDE EMAIL CHECK, for app.* /reset and book.* recovery.
 *
 * Deliberately permissive. The server is the authority on whether an address
 * is real; this only catches the typo that would waste a round trip
 * ("sam@studio" with no dot). Anything stricter starts rejecting valid
 * addresses — plus signs, new TLDs, unicode locals — and a form that refuses
 * your real email is worse than one that sends a mail you never receive.
 *
 * Surrounding whitespace is ignored. `npm run quality:contracts`
 * (scripts/lib/one-way-contracts.js) refuses an inline email regex anywhere
 * else.
 */
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function looksLikeEmail(value: string): boolean {
  return EMAIL.test(value.trim());
}
